import useApi, { ApiOptions } from '../base/useApi';
import MigrationDetailDTO from '@src/adapters/dto/migration/MigrationDetailDTO';

interface Params {
  id: string;
}

interface Result {
  migration: MigrationDetailDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/migration/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetMigration = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useGetMigrationLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetMigration;
